// extracted by mini-css-extract-plugin
export default {"modal":"ConfirmModal-module__modal","header":"ConfirmModal-module__header","content":"ConfirmModal-module__content","footer":"ConfirmModal-module__footer"};